import { useState } from 'react';

const STORAGE_KEY = 'dashboard.capacityView';

/**
 * Persists the selected capacity service view ("PEAK" or a service code) across
 * the Dashboard and Capacity Overview screens so the user's choice follows them
 * between pages and survives reloads.
 */
export function useCapacityViewPreference() {
  const [view, setView] = useState<string>(() => {
    if (typeof window === 'undefined') return 'PEAK';
    return window.localStorage.getItem(STORAGE_KEY) ?? 'PEAK';
  });

  const setAndPersist = (next: string) => {
    setView(next);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, next);
    }
  };

  return [view, setAndPersist] as const;
}
